import React from 'react';
import { Box, Button, Text, VStack } from '@chakra-ui/react';
import EvidenceSentField from './EvidenceSentField';
import { optionalValue } from '../../../../services/text/optionalValue';
import { useTokens } from '../../../../context/TokenProvider';
import { localise } from '../../../../services/lang/lang';
import EvidenceSentMediaField from './EvidenceSentMediaField';
import { clearLocalPreviewUrls } from '../../../../services/photos/remoteSubmissionMediaCache';
const EvidenceSentWrapper = ({ remoteSubmission, onSubmitAnother, }) => {
    const tokens = useTokens();
    const elements = remoteSubmission.elements
        .map((element) => element.name)
        .join(', ');
    const handleSubmitAnother = () => {
        clearLocalPreviewUrls(remoteSubmission.id);
        onSubmitAnother();
    };
    const locationName = remoteSubmission.location.name;
    const locationTypeName = remoteSubmission.location.type.name;
    const locationField = locationName === locationTypeName
        ? locationTypeName
        : `${locationName} (${locationTypeName})`;
    return (React.createElement(VStack, { "data-testid": "evidence_sent_wrapper", w: "100%", align: "flex-start", gap: tokens.Spacing06 },
        React.createElement(EvidenceSentField, { "data-testid": "evidence_sent_wrapper__reference", value: remoteSubmission.reference, name: "Reference number" }),
        React.createElement(Box, { w: "full", h: "36px", borderRadius: tokens.BorderRadius02, bg: tokens.Neutral200, py: tokens.Spacing03, px: tokens.Spacing04 },
            React.createElement(Text, { variant: "blk-800-md-4" }, localise('ISSUE_SUMMARY'))),
        React.createElement(EvidenceSentField, { "data-testid": "evidence_sent_wrapper__location", value: locationField, name: "Location" }),
        React.createElement(EvidenceSentField, { "data-testid": "evidence_sent_wrapper__elements", value: elements, name: "Elements" }),
        React.createElement(EvidenceSentField, { "data-testid": "evidence_sent_wrapper__description", value: optionalValue(remoteSubmission.description), name: "Description" }),
        React.createElement(EvidenceSentMediaField, { remoteSubmission: remoteSubmission }),
        React.createElement(Button, { "data-testid": "report_another_issue_button", w: "100%", variant: "secondary", onClick: handleSubmitAnother }, localise('REPORT_ANOTHER_ISSUE'))));
};
export default EvidenceSentWrapper;
